import { Select, SelectProps, forwardRef } from '@chakra-ui/react'

export interface TinySelectProps extends SelectProps {
}

export const TinySelect = forwardRef((props: TinySelectProps, ref) => {
  return (
    <Select
      ref={ref}
      size="xs"
      sx={{ maxH: 5, m: 0, py: 0.5 }}
      rootProps={{
        sx: {
          maxH: 5,
        },
      }}
      {...props}
    />
  )
})
